const TOKEN_KEY = 'wacd_token'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || ''
}

export function hasToken() {
  const token = getToken()
  return token !== null && token !== undefined && String(token).trim() !== ''
}

export function setToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token)
  }
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

/** 从登录接口返回的 data 中解析 token */
export function extractTokenFromData(data) {
  if (!data) return ''
  if (typeof data === 'string') return data
  return data.token || ''
}
